import { Component, OnInit, ElementRef, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { SettingsHttpService } from '../../../../../app/core/settings';
import { FREE_VEND_DEFAULT_QUOTA } from '../../../../../app/core/settings/_constants/free-vend.constants';
import { FreeVendModeState } from '../../../../../app/core/settings/_types/free-vend.types';
import {
	serializeDesiredFreeVend,
	shouldSyncDesiredFreeVend,
	validateFreeVendEnableQuota
} from '../../../../../app/core/settings/_services/free-vend.util';
import { MatSnackBar } from '@angular/material';
import { MixpanelService } from '../../../../../app/services/mixpanel.service';
import { FeatureFlagService } from '../../../../../app/core/_services/feature-flag.service';

@Component({
  selector: 'kt-remote-ctrl',
  templateUrl: './remote-ctrl.component.html',
  styleUrls: ['./remote-ctrl.component.scss']
})
export class RemoteCtrlComponent implements OnInit, OnDestroy {


	selectedMachine: any;
	machineId: string;
	serial_no: string;
	coilNameTV;
	vendError = false;
	printError = false;
	fetchError = false;
	fetchErrorMsg = '';
	vendErrorMsg = '';
	printErrorMsg = '';
	firstNameTP;
	lastNameTP;
	companyNameTP;
	isVendTest = true;
	connectivity = 1;

	fileType = 'system_log';

	oldDispMode;
	oldCupDrop;
	oldFreeVend;

	fileTypes = [{file_type: 'system_log', file_desc: 'Application Log'}];

	logDate = new Date();

	intervalSubs;
	dispMode: any;
	cupDrop: any;
	freeVend: FreeVendModeState = {
		machine_id: '',
		serial_no: null,
		desired_enabled: 0,
		desired_quota: FREE_VEND_DEFAULT_QUOTA,
		reported_enabled: 0,
		reported_quota: null,
		reported_remaining: null,
		last_command_id: null
	};
	desiredFreeVendEnabled = false;
	desiredFreeVendQuota = FREE_VEND_DEFAULT_QUOTA;
	canAccessFreeMode = false;

	ooOrder;

	// Machines with no shadow key are on. stripe-integration-101 defaults vouchers_enabled to true.
	vouchersEnabled = true;

	shadowData;

	reported;

	@ViewChild('fnTP', {static: false}) fnTP: ElementRef;

	@ViewChild('lnTP', {static: false}) lnTP: ElementRef;

	constructor(private http: SettingsHttpService, private _snackBar: MatSnackBar, private cdr: ChangeDetectorRef,
		private mixpanelService: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService,
		private featureFlagService: FeatureFlagService) { }

	ngOnInit() {
		this.selectedMachine = this.machineRouteService.getMachine(this.route);
		if (!this.selectedMachine) return;
		this.machineId = this.selectedMachine.machine_id;
		this.serial_no = this.selectedMachine.serial_no;
		this.dispMode = { machine_id: this.machineId, serial_no: this.serial_no, reported_mode: 'office', desired_mode: 'office' };
		this.cupDrop = { machine_id: this.machineId, serial_no: this.serial_no, reported_mode: 'Disable', desired_mode: 'Enable' };
		this.freeVend = {
			machine_id: this.machineId,
			serial_no: this.serial_no,
			desired_enabled: 0,
			desired_quota: FREE_VEND_DEFAULT_QUOTA,
			reported_enabled: 0,
			reported_quota: null,
			reported_remaining: null,
			last_command_id: null
		};
		this.getConnState();
		this.getShadowDetails();
		this.getDispenseMode();
		this.getCupDrop();
		this.canAccessFreeMode = this.featureFlagService.canAccessFreeMode();
		if (this.canAccessFreeMode) {
			this.getFreeVendMode();
		}
		this.intervalSubs = setInterval(() => {
			this.getConnState();
			this.getCupDrop();
			this.getDispenseMode();
			if (this.canAccessFreeMode) {
				this.getFreeVendMode();
			}
			this.cdr.detectChanges();
		}, 15000);

		this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
			machineName: this.selectedMachine.machine_name,
			machineId: this.selectedMachine.machine_id,
			serialNo: this.selectedMachine.serial_no
		});
	}

	getShadowDetails(){
		this.http.getShadowData(this.selectedMachine.serial_no)
		.subscribe(shData => {
			if(shData.payload){
				try {
					// console.log(JSON.parse(shData.payload));
					let init = false;
					this.shadowData = JSON.parse(shData.payload).state;
					this.reported = this.shadowData.reported;
					if(this.shadowData.delta){
						let delta = this.shadowData.delta;
						if(delta.hasOwnProperty('out_of_order') && delta.out_of_order != null){
							init = true;
							this.ooOrder = (this.reported.out_of_order == 1)?true:false;
						}
					}
					if(this.reported.hasOwnProperty('out_of_order') && this.reported.out_of_order != null && !init){
						this.ooOrder = (this.reported.out_of_order == 1)?true:false;
					}
					this.vouchersEnabled = this.voucherFlagFromReported(this.reported);
					setTimeout(() => {
						this.cdr.detectChanges();
					}, 10);
				} catch (error) {
					console.log(error);
				}
			}else{
				console.log('No Shadow yet');
			}
		});
	}

	getDispenseMode(){
		this.http.getDispenseMode(this.machineId).
		subscribe((dispMode: any) => {
			this.oldDispMode = JSON.stringify(dispMode);
			this.dispMode = dispMode;
			// console.log({dispMode});
		});
	}

	onModeChange(){
		// console.log("Changed Mode:", this.dispMode);
		if((this.oldDispMode != JSON.stringify(this.dispMode))){
			this.http.changeVendMode(this.dispMode).
			subscribe(() => {
				// console.log("Subscribed Mode: ", this.dispMode.desired_mode);
				this.showSnackBar('Sent to machine', 5000);
				// this.showSnackBar('Sent to machine. Recommended to enable Cup Drop.', 5000);
				if(this.dispMode.desired_mode == "retail"){
					// this.showSnackBar("Recommended to enable Cup Drop", 3000);
					alert("Recommended to enable Cup Drop")
				}
			},error => {
				console.log(error);
				this.showSnackBar('Unable to send, something went wrong!!', 3000);

			});
		}else{
			this.showSnackBar('No changes made!!', 3000);
		}
		this.getDispenseMode();

	}

	getCupDrop(){
		this.http.getCupDrop(this.machineId).
		subscribe((cupDrop: any) => {
			this.oldCupDrop = JSON.stringify(cupDrop);
			this.cupDrop = cupDrop;
			// console.log("Cup Drop: " , {cupDrop});
		});
	}

	getFreeVendMode(){
		this.http.getFreeVendMode(this.machineId).
		subscribe((freeVend: FreeVendModeState) => {
			this.freeVend = freeVend;
			if (shouldSyncDesiredFreeVend(
				this.oldFreeVend,
				this.desiredFreeVendEnabled,
				this.desiredFreeVendQuota
			)) {
				this.desiredFreeVendEnabled = !!freeVend.desired_enabled;
				this.desiredFreeVendQuota = freeVend.desired_quota != null
					? freeVend.desired_quota
					: FREE_VEND_DEFAULT_QUOTA;
				this.oldFreeVend = serializeDesiredFreeVend(
					this.desiredFreeVendEnabled,
					this.desiredFreeVendQuota
				);
			}
		});
	}

	onFreeVendChange(){
		const nextState = serializeDesiredFreeVend(
			this.desiredFreeVendEnabled,
			this.desiredFreeVendQuota
		);
		if (this.oldFreeVend === nextState) {
			this.showSnackBar('No changes made!!', 3000);
			return;
		}
		if (this.desiredFreeVendEnabled) {
			const quotaError = validateFreeVendEnableQuota(
				this.desiredFreeVendQuota,
				this.freeVend.reported_quota,
				this.freeVend.reported_remaining
			);
			if (quotaError) {
				this.showSnackBar(quotaError, 5000);
				return;
			}
		}
		this.http.changeFreeVendMode({
			machine_id: this.machineId,
			serial_no: this.serial_no,
			enabled: this.desiredFreeVendEnabled,
			quota: this.desiredFreeVendEnabled ? this.desiredFreeVendQuota : undefined
		}).subscribe(() => {
			this.oldFreeVend = nextState;
			this.showSnackBar('Sent to machine', 5000);
			this.getFreeVendMode();
		}, error => {
			console.log(error);
			this.showSnackBar('Unable to send, something went wrong!!', 3000);
		});
	}

	onCupDrop(){
		if((this.oldCupDrop != JSON.stringify(this.cupDrop))){
			this.http.changeCupDrop(this.cupDrop).
			subscribe(() => {
				// this.showSnackBar('Sent to machine', 5000);
				// this.showSnackBar('Sent to machine. Recommended to enable Retail Dispense.', 5000);
				if(this.cupDrop.desired_mode == "enable"){
					// this.showSnackBar("Recommended to enable Cup Drop", 3000);
					alert("Recommended to enable Retail Dispense. Please Enable it from Dispense Mode.");
				}else{
					this.showSnackBar('Sent to machine', 5000);
				}
			},error => {
				console.log("Cup Drop Error: ", error);
				this.showSnackBar('Unable to send, something went wrong!!', 3000);
			});
		}else{
			this.showSnackBar('No changes made!!', 3000);
		}
	}

	getFileTypes() {
		this.http.getFetchFileTypes().
		subscribe((fileTypes: any[]) => {
			this.fileTypes = fileTypes;
		});
	}

	getConnState() {
		this.http.getMachineConnState(this.selectedMachine.machine_id)
		.subscribe((state: any) => {
			this.connectivity = state.connectivity;
		}, error => {
			console.log(error);
		});
	}

	onReboot(){
		// const formObj = {
		// 	machine_id: this.machineId
		// };
		this.http.remoteReboot(this.selectedMachine.machine_id)
		.subscribe(result => {
			this.showSnackBar('Sent to machine', 3000);
		}, error => {
			console.log(error);
			this.showSnackBar('Unable to send', 0);
		});
	}

	onPrint() {
		if (!this.machineId || !this.firstNameTP || !this.lastNameTP
			|| !this.companyNameTP) {
			this.printError = true;
			this.printErrorMsg = 'Please provide all info';
		} else {
			const formObj = {
				machine_id: this.machineId,
				first_name: this.firstNameTP,
				last_name: this.lastNameTP,
				company_name: this.companyNameTP
			};
			this.http.testPrint(formObj)
			.subscribe(result => {
				this.showSnackBar('Sent to machine', 3000);
			}, error => {
				console.log(error);
				this.showSnackBar('Unable to print', 0);
			});
		}
	}

	onFetchLog() {
		if (!this.fileType || !this.logDate) {
			this.fetchError = true;
			this.fetchErrorMsg = 'Please provide all info';
		} else {
			const formObj = {
				machine_id: this.machineId,
				date: this.logDate,
				file_type: this.fileType
			};
			this.http.remoteFetchFiles(formObj)
			.subscribe(result => {
				this.showSnackBar('Sent to machine', 3000);
			}, error => {
				console.log(error);
				this.showSnackBar('Unable to send', 0);
			});
		}
	}

	voucherFlagFromReported(reported): boolean {
		if (!reported || !reported.hasOwnProperty('vouchers_enabled') || reported.vouchers_enabled == null) {
			return true;
		}
		return reported.vouchers_enabled === true || reported.vouchers_enabled === 1;
	}

	onVouchers(){
		if(this.vouchersEnabled != null){
			const obj = {
				serial_no: this.selectedMachine.serial_no,
				vouchers_enabled: this.vouchersEnabled === true
			};
			this.http.remoteVouchers(obj)
			.subscribe(result => {
				this.showSnackBar('Sent to machine', 3000);
			}, error => {
				console.log(error);
				this.showSnackBar('Unable to send', 0);
			});
		}else{
			this.showSnackBar("No Changes Made!!!", 3000);
		}
	}

	onOOO(){
		if(this.ooOrder != null){
			let obj = {
				serial_no: this.selectedMachine.serial_no,
				out_of_order: (this.ooOrder)?1:0
			}
			this.http.remoteOutOfOrder(obj)
			.subscribe(result => {
				this.showSnackBar('Sent to machine', 3000);
			}, error => {
				console.log(error);
				this.showSnackBar('Unable to send', 0);
			});
		}else{
			this.showSnackBar("No Changes Made!!!", 3000);
		}
	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

	ngOnDestroy() {
		clearInterval(this.intervalSubs);
	}



}
